import { getSession } from 'next-auth/react';
import axios from 'axios';

/**
 * Creates an Axios instance with a base URL and interceptors for authentication and error handling.
 *
 * The Axios instance is pre-configured with a request interceptor that adds an
 * `Authorization` header using a token from `getSession()` if available, and a
 * response interceptor that logs errors to the console.
 *
 * @param baseURL - The base URL for the Axios instance.
 * @returns The configured Axios instance.
 */
const apiClient = (baseURL: string) => {
  const defaultOptions = {
    baseURL,
  };

  const instance = axios.create(defaultOptions);

  instance.interceptors.request.use(async (request) => {
    const session = await getSession();
    const accessToken = session?.user?.accessToken;
    if (accessToken) {
      request.headers.Authorization = `Bearer ${accessToken}`;
    }
    return request;
  });

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      //TODO: add http handler error
      // eslint-disable-next-line no-console
      console.error(`error`, error);
    }
  );

  return instance;
};

export default apiClient;
